// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"8faa7ae1","453":"4f451148","958":"8ee2dea5"}[chunkId] + ".chunk.js";
};